import { localSettingsService } from './localSettingsService';

export default class ServiceConstantsProvider {
    public static getClientId(): string {
        return localSettingsService.getLocalSettings().clientId;
    }

    public static getHostName = (): string => {
        let hostUrl: string;
        if (localSettingsService.getLocalSettings().useFortraCloudServices) {
            hostUrl = ServiceConstantsProvider.getOriginBaseUrl().replace('oa-', '');
        } else {
            hostUrl = localSettingsService.getLocalSettings().selfHostedServicesUrl;
        }

        return hostUrl;
    };

    public static getLoginAuthority = (): string => {
        return (
            localSettingsService.getLocalSettings().loginAuthority +
            '/' +
            localSettingsService.getLocalSettings().loginTenantId
        );
    };

    public static getAuthUrl = (): string => {
        return ServiceConstantsProvider.getOriginBaseUrl() + '/auth.html';
    };

    public static getAlertsWithDisabledOkUrl = (): string => {
        return ServiceConstantsProvider.getOriginBaseUrl() + '/alerts?enableOk=false';
    };

    public static getAlertsWithEnabledOkUrl = (): string => {
        return ServiceConstantsProvider.getOriginBaseUrl() + '/alerts?enableOk=true';
    };

    public static getFailOpenCloseAlertWithEnabledOkUrl = (): string => {
        return ServiceConstantsProvider.getOriginBaseUrl() + '/failOpenCloseAlert?enableOk=true&&mode=';
    };

    public static getCustomActionFailureDialogUrl = (title: string, errorMessage: string, severity: string): string => {
        const queryString = new URLSearchParams({ title: title, errorMessage: errorMessage, severity: severity });

        return ServiceConstantsProvider.getOriginBaseUrl() + `/customActionFailure?${queryString}`;
    };

    public static getForceClassificationUrl = (): string => {
        return ServiceConstantsProvider.getOriginBaseUrl() + '/select-classification?mode=force';
    };

    public static getSuggestClassificationUrl = (): string => {
        return ServiceConstantsProvider.getOriginBaseUrl() + '/select-classification?mode=suggest';
    };

    public static getLicensingValidationUrl = (productName: string): string => {
        return `${ServiceConstantsProvider.getHostName()}/tenantinformation/api/TitusLicense/authorize?product=${productName}`;
    };

    public static getEventCollectorUrl = (): string => {
        return `${ServiceConstantsProvider.getHostName()}/eventcollector/api/v2/events`;
    };

    public static getSsoApiScope = (): string => {
        const host = new URL(ServiceConstantsProvider.getOriginBaseUrl()).host;
        const clientId = ServiceConstantsProvider.getClientId();
        return `api://${host}/${clientId}/access_as_user`;
    };

    private static getOriginBaseUrl = (): string => {
        return window.location.origin;
    };
}
